import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  workunit_name?: string;
};

const WorkunitNameCell = React.memo((row: KpiWorkunitGridData) => (
  <span>
    {row?.workunit_name && (
      <Tooltip title={row.workunit_name}>
        <Typography variant="body2" noWrap>
          {row.workunit_name}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default WorkunitNameCell;
